const products = {
	add_button: "Add Product",
	alerts: {
		product_added: "Product <strong>{{name}}</strong> added successfully!",
		product_edited: "Product <strong>{{name}}</strong> edited successfully!",
	},
	delete_dialog: {
		description: "Do you want to delete product <strong>{{name}}</strong>?",
		success_alert: "Deletion of product was successful!",
		title: "Delete Product",
		unknown_alert: "Deletion of product failed! Please try again later.",
	},
	errors: {
		invalid_price_calculation: "Invalid price calculation",
		invalid_test_formula_calculation:
			"Error: not all variables are entered or the formula is incorrect",
		missing_required_variables: "Error: q and pr variables must be present in the formula.",
	},
	product_add: {
		form: {
			description: "Description",
			formula: "Formula",
			formula_check: "Uses a Formula",
			formula_helper: `The values 'q' (Quantity) & 'pr' (Price Recommended) are mandatory values. Thus, they must be used in the formula. The value 'pp'(Price Purchase) is optional.

														<strong>Accepted operators are:</strong>
															+ (add)
															- (subtract)
															* (multiply)
															/ (divide)
															% (modulus)
															** (exponent)
															() (parentheses to group expressions)`,
			name_de: "Product Name (German)",
			name_en: "Product Name (English)",
			name_nl: "Product Name",
			per: "Per",
			price_purchase: "Purchase Price",
			price_recommended: "Recommended Price",
			product_code: "Product Code",
			product_code_invalid: "No HostFact product found with the above code",
			product_groups: "Product Groups",
			product_number: "HostFact Product Number",
			quantity: "Quantity",
			test_your_formula: {
				price: "Price",
				result: "Result:",
				title: "Test Your Formula:",
			},
			unit: "Unit",
		},
		section_description: "Using this form, you can create a new product.",
		section_title: "Add Product",
		title: "Add Product",
	},
	product_edit: {
		section_description: "Using this form, you can edit the selected product.",
		section_title: "Edit Product",
		title: "Edit Product",
	},
	table: {
		filters: {
			disabled: "Show deleted products",
		},
		headers: {
			cost: "Cost Price",
			description: "Description",
			formula: "Formula",
			hostfact_number: "HostFact Number",
			price: "Recommended Price",
			product_code: "Product Code",
			product_group: "Product Group",
			product_name: "Product Name",
			sell_unit: "Sales Unit",
		},
	},
	title: "Products",
};

export default products;
